import { defineComponentClasses } from '@visiontree/vue-ui'

interface Structure {
  container: never
  input: never
  label: never
  end: never
}

type Options = Record<never, never>

export const getSearchInputClasses = defineComponentClasses<Options, Structure>(
  {
    classes: {
      container: 'relative flex flex-row items-center',
      input:
        'block w-full text-sm py-3 pl-6 pr-12 text-neutral-900 border border-neutral-300 rounded-full bg-neutral-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-neutral-700 dark:border-neutral-600 dark:placeholder-neutral-400 dark:text-neutral-100 dark:focus:ring-primary-500 dark:focus:border-primary-500',
      label: 'sr-only',
      end: '-ml-10',
    },
  }
)
